// Versioning
export const majorVersion = 1;
export const minorVersion = 20;
export const hotfixVersion = 1;
export const buildVersion = 124;
